import { map, isEmpty } from "lodash";

import * as c from "../actions/constants";
import {getOrganizationUserDetail} from "../actions/resourceActions";

const initialState = {
  providers: null,
  projects: null,
  organization: null,
  organizations: null,
  organizationsAdmin: null,
  organizationsDispatcher: null,
  organizationsMember: null,
  organizationsAdminDispatcher: null,
  organizationPackageMapping: null,
  organizationPackageMapping_forMyOrg: null,
  contacts: null,
  clients: null,
  dispatchers: null,
  hosts: null,
  hostCategories: null,
  userOrganizations: null,
  userOrganizations_byType: {
      related: [],
      owned: [],
      administered: [],
  },
  myAtollon_selectedUserOrganizationTypeName: null,
  packages: null,
  users: null,
  project: null,
  person: null,
  resources: null,
  resource: null,
  rights: null,
  page: null,
  organizationUsers: null,
  organizationUserDetails: null,
  touchUsers: null,
  organizationTemplates: null,
  organizationUsersAdmin: null,
  organizationUsersOwner: null,
  organizationUsersUser: null,
  serverCategories: null,
  userOrganizations_withType_related: null,
  userOrganizations_withType_owned: null,
  userOrganizations_withType_administered: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
      case c.RESOURCES:
      {
          let oldState = state;
          let newState = { ...state, ...action.payload };

          // Keep existing subarrays intact
          if( action.payload.userOrganizations_byType )
          {
              newState.userOrganizations_byType = {...state.userOrganizations_byType, ...action.payload.userOrganizations_byType };
          }

          return newState;
      }

    case c.RESOURCES_HOST:
      return {
        ...state,
        hosts: map(
          state.hosts,
          h => (h.id === action.payload.host.id ? action.payload.host : h)
        )
      };
    case c.RESOURCES_SERVERS:
      return {
        ...state,
        hosts: map(
          state.hosts,
          h =>
            h.id !== action.payload.hostId
              ? h
              : { ...h, servers: action.payload.servers }
        )
      };
    case c.RESOURCES_SERVER:
      return {
        ...state,
        hosts: map(
          state.hosts,
          h =>
            h.id !== action.payload.hostId
              ? h
              : {
                  ...h,
                  servers: map(
                    h.servers,
                    s =>
                      s.id === action.payload.server.id
                        ? action.payload.server
                        : s
                  )
                }
        )
      };
    case c.RESOURCES_ORGANIZATIONS:
      return {
        ...state,
        hosts: map(
          state.hosts,
          h =>
            h.id !== action.payload.hostId
              ? h
              : {
                  ...h,
                  servers: map(
                    h.servers,
                    s =>
                      s.id === action.payload.serverId
                        ? { ...s, organizations: action.payload.organizations }
                        : s
                  )
                }
        )
      };
    case c.RESOURCES_ORGANIZATION:
      return {
        ...state,
        hosts: map(
          state.hosts,
          h =>
            h.id !== action.payload.hostId
              ? h
              : {
                  ...h,
                  servers: map(
                    h.servers,
                    s =>
                      s.id === action.payload.serverId
                        ? {
                            ...s,
                            organizations: map(
                              s.organizations,
                              o =>
                                o.id === action.payload.organization.id
                                  ? action.payload.organization
                                  : o
                            )
                          }
                        : s
                  )
                }
        )
      };
    case c.RESOURCES_USER_ORGANIZATION:
      return {
        ...state,
        userOrganizations: isEmpty(state.userOrganizations)
          ? [action.payload.userOrganization]
          : map(
              state.userOrganizations,
              o =>
                o.id === action.payload.userOrganization.id
                  ? action.payload.userOrganization
                  : o
            )
      };

      //
      //    modifiable
      //
      case c.RESOURCES_organizationPackageMapping:
      {
        let ret = {
            ...state,
            organizationPackageMapping: (
                isEmpty(state.organizationPackageMapping)
                    ? action.payload.organizationPackageMapping
                    : { ...state.organizationPackageMapping, ...action.payload.organizationPackageMapping }
            )
        };
        return ret;
      }

      case c.RESOURCES_organizationPackageMapping_forOrg:
      {
          let newState = { ...state}; // duplicate because redux wants it FIXME: does he ?
          let {
              key,
              value
          } = action.payload;
          newState.organizationPackageMapping_forOrg[key] = value;
          return newState;
      }

      //
      //    non modifiable
      //
      case c.RESOURCES_organizationUserDetails:

        /*
            let payload = {};
            payload.organizationUserDetails = {};
            payload.organizationUserDetails[userIdAsEmail] = content;
       */
      {

        let ret = {
          ...state,
          organizationUserDetails: (
              isEmpty(state.organizationUserDetails)
              ? action.payload.organizationUserDetails
              : { ...state.organizationUserDetails, ...action.payload.organizationUserDetails}
          )
        };

        // console.log( 'RESOURCES_organizationUserDetails', state, action, ret );
        return ret;
      }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/resourceReducer.js